import React, { 
    FC,
 } from 'react'
 import '../App.css'
 import "react-toggle/style.css"
 import styles from './DateTimePicker.module.css'
import { dateToDisplayableTime, dateToInputDate, dispayDateAndTimeToTransmissionDate, transmissionDateToDisplayableDate, transmissionDateToDisplayableTime, transmissionDateToInputDate } from '../utils/dateUtils'
import Toggle from 'react-toggle'
 interface Props {
    onDateChange : ( transmissionDate : string | null ) => void,
    transmissionDateTime : string | null | undefined,
    dateDescription : string | null | undefined,
    dateLabel : string | null | undefined,
    timeDescription : string | null | undefined,
    timeLabel : string | null | undefined,
    nullDescription : string | null | undefined
}

 export const DateTimePicker: FC<Props> = ({
    onDateChange,
    transmissionDateTime,
    dateDescription = '',
    dateLabel = '',
    timeDescription = '',
    timeLabel = '',
    nullDescription = '',
 }: Props) => {
        const [inputDate, setInputDate] = React.useState<string | null>(transmissionDateToInputDate(transmissionDateTime??dateToInputDate(new Date())))
        const [inputTime, setInputTime] = React.useState<string | null>(transmissionDateToDisplayableTime(transmissionDateTime??dateToDisplayableTime(new Date())))
     return (
         <>
         <div className={styles.toggle}>
         { nullDescription ?<h3>{nullDescription}</h3> : null}
         <br></br>
         <Toggle checked={inputDate == null &&  inputTime== null} onChange={(e) => {
            if (inputDate && inputTime) {
                setInputDate(null)
                setInputTime(null)
                onDateChange(null)
            }
            else {
                setInputDate(transmissionDateToInputDate(new Date().toISOString()))
                setInputTime(transmissionDateToDisplayableTime(new Date().toISOString()))
                onDateChange(dispayDateAndTimeToTransmissionDate(e.target.value, inputTime ?? '')??"0000:01:01T00:00:00")
            }
         }} />
         </div>
         {inputDate !== null && inputTime!= null ? 
         <>
            { dateDescription ?<h2>{dateDescription}</h2> : null }
            <br></br>
            <label className={styles.label} htmlFor='txtEventDate'>{dateLabel}</label>  
            <br></br>
            <input 
                className={styles.textboxDate}
                type="date"
                required
                value={inputDate ?? ''}
                onChange={(e) => {
                    if (e.target.value !== "") {
                        
                        setInputDate(e.target.value)
                        onDateChange(dispayDateAndTimeToTransmissionDate(e.target.value, inputTime ?? '')??"0000:01:01T00:00:00")
                    }
                }}
              />
            <br></br>
            { timeDescription ?
                <>
                    <h2>{timeDescription}</h2>
                    <br></br>
                </>
                : null}

        <label className={styles.label} htmlFor='txtEventTime'>{timeLabel}</label>
        <br></br>
            <input 
                type="Time" 
                className={styles.textboxTime}
                required
                value={inputTime ?? ''}
                onChange={(e) => {
                    if (e.target.value !== "") {
                    setInputTime(e.target.value)
                    onDateChange(dispayDateAndTimeToTransmissionDate(inputDate ?? '', e.target.value))
                    }
                }}
            />
            </>
            : null}
          </>
     )
 }


